import React from "react";
import { Box, Checkbox, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import informationOutline from "@iconify/icons-mdi/information-outline";
import { Icon } from "@iconify/react";
import MyTaxApplicationCardInfoItem from "my-tax/components/application-card-info-item/application-card-info-item";
import MyTaxModifiedStatementInfo from "my-tax/components/modified-statement-info/modified-statement-info";
import { OcCustomTooltip } from "oc/components";

interface MyTaxModifiedStatementCheckProps {
  label: string;
  name: string;
  value: boolean;
  onChange: (event: { key: string; value: boolean }) => void;
  disabled: boolean;
  isMobile: boolean;
}

export const MyTaxModifiedStatementCheck: React.FC<MyTaxModifiedStatementCheckProps> = ({
  label,
  name,
  value,
  onChange,
  disabled,
  isMobile,
}) => {
  const theme = useTheme();

  return (
    <Box display="flex" alignItems="center">
      <MyTaxApplicationCardInfoItem
        label={label}
        isMobile={isMobile}
        disabled={disabled}
        value={
          <Checkbox
            id="modified-application-box"
            checked={value}
            onChange={(e) => onChange({ key: name, value: e.target.checked })}
            color="secondary"
            style={{
              backgroundColor: "transparent",
              color: disabled
                ? theme.palette.gray60.main
                : theme.palette.darkBase.main,
            }}
            disabled={disabled}
          />
        }
      />
      <OcCustomTooltip title={<MyTaxModifiedStatementInfo />} placement="right">
        <IconButton
          aria-label="Info"
          style={{
            marginTop: "-9px",
            padding: "12px",
            color: disabled
              ? theme.palette.gray60.main
              : theme.palette.darkBase.main,
          }}
        >
          <Icon
            icon={informationOutline}
            width="20px"
            color={
              disabled ? theme.palette.gray60.main : theme.palette.darkBase.main
            }
          />
        </IconButton>
      </OcCustomTooltip>
    </Box>
  );
};

export default MyTaxModifiedStatementCheck;
